import { Cell, Pie, PieChart, ResponsiveContainer, Tooltip } from "recharts";
import { nf } from "@/lib/format";
import { L } from "@/i18n";
import { Panel } from "./Panel";
import { ChartTooltip } from "./ChartTooltip";

export const UserStatusChart = ({ users }) => {
  const data = [
    { key: "approved", name: L("Approved", "Aprovados"), value: users.approved, color: "#10b981" },
    { key: "pending", name: L("Pending", "Pendentes"), value: users.pending, color: "#f59e0b" },
    { key: "blocked", name: L("Blocked", "Bloqueados"), value: users.blocked, color: "#f43f5e" },
    { key: "rejected", name: L("Rejected", "Rejeitados"), value: users.rejected, color: "#64748b" },
  ];
  return (
    <Panel testId="chart-user-status" className="lg:col-span-4" title={L("Student status", "Estado dos alunos")} subtitle={L("Distribution by account status", "Distribuição por estado de conta")}>
      <div className="relative h-48">
        <ResponsiveContainer width="100%" height="100%" initialDimension={{ width: 300, height: 192 }}>
          <PieChart>
            <Pie data={data.filter((d) => d.value)} dataKey="value" innerRadius={58} outerRadius={80} paddingAngle={data.filter((d) => d.value).length > 1 ? 3 : 0} stroke="none">
              {data.filter((d) => d.value).map((d) => <Cell key={d.name} fill={d.color} />)}
            </Pie>
            <Tooltip content={<ChartTooltip unit={L("users", "utilizadores")} />} />
          </PieChart>
        </ResponsiveContainer>
        <div className="absolute inset-0 grid place-items-center pointer-events-none">
          <div className="text-center">
            <p className="font-mono text-2xl font-bold text-slate-50">{nf.format(users.total)}</p>
            <p className="text-[10px] font-mono uppercase tracking-widest text-slate-500">total</p>
          </div>
        </div>
      </div>
      <ul className="mt-4 grid grid-cols-2 gap-2">
        {data.map((d) => (
          <li key={d.name} className="flex items-center justify-between rounded-md bg-[#0f172a] px-3 py-2 text-xs" data-testid={`user-status-${d.key}`}>
            <span className="flex items-center gap-2 text-slate-400">
              <span className="h-2 w-2 rounded-full" style={{ background: d.color }} />
              {d.name}
            </span>
            <b className="font-mono text-slate-100">{d.value}</b>
          </li>
        ))}
      </ul>
    </Panel>
  );
};
